<template>

	<div :class="{'hide': loading}">
		<div :class="{'spinner loading': loading}"></div>

		<div class="sidebar-item prices" v-bind:style="styleObject">
			<p id="topic-title-form">Place an order</p>

			<div v-if="$config.type !== 'white'" class="cart-overview-item big">
				<select v-model="selectedType" id="type" name="type">
					<option v-for="(singleType, key) in $types" v-bind:value="key">
						{{singleType}}
					</option>
				</select>
			</div>

			<div class="cart-overview-item big">
				<select @change="calculate()" v-model="selectedQuality" id="quality" name="quality">
					<option v-for="(singlequality, key) in $qualities" v-bind:value="key">
						{{singlequality}}
					</option>
				</select>
			</div>

			<div style="width: 48%; float: left;">
			<div class="cart-overview-item small"><p class="text-header">Pages:</p></div>
			<div class="cart-overview-item big">
				<label for="pages" class="select-block pages">
					<div id="plus-minus" class="plus-minus">
						<div id="main-pages-qty" class="contentspin clearfix">
							<input v-on:click="pagesMinusHandler()" class="buttonspin qtyminus" value="−" type="button">
							<input v-model="pages" @change="calculate()"
								   class="ui-spinner"
								   name="pages" id="pages" type="text">
							<input v-on:click="pagesPlusHandler()" class="buttonspin qtyplus" value="+" type="button">
						</div>
					</div>
				</label>
			</div>
			</div>

			<div style="width: 48%; float: right;">
			<div class="cart-overview-item small"><p class="text-header">Deadline:</p></div>
			<div class="cart-overview-item big">
				<select @change="calculate()" v-model="selectedDeadline" id="deadline" name="deadline">
					<option v-for="(singleDeadline, key) in $deadlines" v-bind:value="key">
						{{singleDeadline}}
					</option>
				</select>
			</div>
			</div>
			<div class="clearfix"></div>



			<div class="cart-overview-item total-price big">
				<p class="text-header total big">Total Price:</p>
				<p class="text-header price">
					<span class="primary">${{totalPrice}}</span></p>
			</div>

			<a v-if="$config.type === 'white'" :href="orderNowUrl" name="submit-button" class="button mid primary">Order now</a>
			<a v-else :href="orderNowUrl" name="submit-button" class="button mid primary" id="call-to-action sidebar">Write a paper</a>
			<div class="clearfix"></div>
		</div>


	</div>
</template>


<script>
    import moment from 'moment';
    import pricingMixin from '../../../Mixins/pricingMixin.js';
    import plusMinusButtonsMixin from '../../../Mixins/plusMinusButtonsMixin';
    import deadlineMixin from "../../../Mixins/deadlineMixin";


    export default {
        mixins: [pricingMixin, plusMinusButtonsMixin, deadlineMixin],

        props: ['order', 'shadow'],
        data() {
            return {

                loading: true,
                type: 1,
                pages: 1,
                pricePerPage: 0,
                totalPrice: 0,
                selectedDeadline: 7,
                selectedQuality: 1,
                selectedType: 1,
                styleObject: {
                    boxShadow: this.shadow ? '0 0 10px rgba(0, 0, 0, 0.12)' : 'none',
                }
            }
        },

        created(){

            this.calculate();

            this.loading = false;

        },

        computed:{

            orderNowUrl() {
                return '/order?type='+this.selectedType+'&deadline='+this.selectedDeadline+'&quality='+this.selectedQuality+'&pages='+this.pages
            }

        },

        methods: {

            calculate(deadline = this.selectedDeadline, quality = this.selectedQuality){
                this.selectedDeadline = deadline;
                this.selectedQuality = quality;
                this.pricePerPage = this.priceCalculation(this.selectedDeadline, this.selectedQuality);
                this.totalPrice = this.pricePerPage * this.pages;
            },
            pagesMinusHandler(){
                this.pagesMinus();
                this.calculate();
            },
            pagesPlusHandler(){
                this.pagesPlus();
                this.calculate();
            },

        }

    }
</script>